import React, { useEffect } from "react";
import { Input, Modal } from "antd";
import { useFormik } from "formik";
import { updateBrickCollection } from "../../utils";

interface Props {
  organization: string;
  id: string;
  open: boolean;
  onClose(): void;
}

const EditNameModal: React.FC<Props> = ({ open, organization, id, onClose }) => {
  const formik = useFormik({
    initialValues: {
      name: "",
    },
    onSubmit: async (values) => {
      await updateBrickCollection(organization, id, values);
      onClose();
    },
  });

  useEffect(() => {
    formik.resetForm();
  }, [open]);

  return (
    <Modal
      title="Wijzig naam"
      open={open}
      closable={false}
      onCancel={() => onClose()}
      onOk={() => formik.handleSubmit()}
      okButtonProps={{
        disabled: formik.values.name === "",
      }}
    >
      <Input
        name="name"
        placeholder="naam"
        onChange={formik.handleChange}
        value={formik.values.name}
      />
    </Modal>
  );
};

export default EditNameModal;
